export const youtubeIcon = require('../src/assets/youtubeIcon.svg')
export const noInternetIcon = require('../src/assets/no_internet_icon.svg')
export const retryIcon = require('../src/assets/retry_icon.svg')
